import * as Yup from "yup";

export const searchMethods = {
    packages: {
        id: "packages",
        description: "Aggregate all items into packages at one times settings"
    },
    documents: {
        id: "documents",
        description: "Use Existing Package to Pack"
    }
}

export const validateRowSchema = Yup.object().shape({
    documentId: Yup
        .string()
        .required("Required"),
    itemId: Yup
        .string()
        .required("Required"),
})

export const validationSchema = Yup.object({
    rows: Yup.array().of(validateRowSchema),
    search: Yup.lazy((val) => {

        let method = val?.method? val.method : ''
        
        // let valueSchema;

        if(method === searchMethods.packages.id){
            
            return Yup.object().shape({
                method: Yup
                    .string()
                    .oneOf(Object.keys(searchMethods))
                    .required("Required"),
                packageNo: Yup
                    .string()
                    .required("Required")
            })

        }

        return Yup.object().shape({})
            
    }),
})

export const initialRowValues = {
    documentId: 0,
    documentDate: "",
    documentNumber: "",
    docItemId: "",
    itemId: "",
    qty: {
        maxQty: "0",
        value: "0",
        itemQty: "0"
    },
    name: "",
    code: "",
    description: "",
    uomId: "",
    uomName: "",
    price: "",
}

export const initialValues = {
    filterDocumentId: "all",
    rows: [],
    packages: [],
    search: {
        method: searchMethods.packages.id,
        packageNo: ""
    }
}
